import { Link } from "react-router-dom";
import "./css/error404.css";

const Error404 = () => {
  return (
    <div className="error-404">
      <div>
        <div className="error-img">
          <img src="/images/error404.png" alt="Error 404" />
        </div>
        <div className="error-text">
          <h1>Oops! Trang không tồn tại</h1>
          <p>
            Có vẻ như trang bạn đang tìm kiếm không tồn tại hoặc đã bị di chuyển
            đến một địa chỉ khác.
          </p>
        </div>
        <div className="spinner-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            aria-hidden="true"
            className="spinner-icon"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m15.75 15.75-2.489-2.489m0 0a3.375 3.375 0 1 0-4.773-4.773 3.375 3.375 0 0 0 4.774 4.774ZM21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            ></path>
          </svg>
        </div>
        <div className="error-btn">
          <Link to="/" className="link-err go-home">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
              ></path>
            </svg>{" "}
            Trang chủ
          </Link>

          <Link
            to="*"
            className="link-err come-back"
            onClick={e => {
              e.preventDefault();
              window.history.back();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              aria-hidden="true"
              data-slot="icon"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
              ></path>
            </svg>{" "}
            Quay lại
          </Link>
        </div>
        <div className="error-text mt-sm-5 mt-3">
          <h6>Bạn có thể thử:</h6>
          <ul>
            <li>Kiểm tra lại đường dẫn URL</li>
            <li>Làm mới trang</li>
            <li>Quay lại trang trước</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Error404;
